module.exports = __webpack_public_path__ + "img/phone_step3.07e69154.png";